// extracted by mini-css-extract-plugin
module.exports = {"opacityCover":"DisabledCover_opacityCover__3b5rM"};